"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ShowMoreButton = void 0;
const lit_1 = require("lit");
const decorators_js_1 = require("lit/decorators.js");
const icon_names_1 = require("@/components/common/icon/icon-names");
require("@/components/common/button/button");
/**
 * 목록의 다음 항목을 이어서 불러오는 버튼.
 * 불러온 항목은 다시 접히지 않으므로 상태를 갖지 않는다.
 * 목록 어디서나 같은 행동이라 레이블은 받지 않고 고정한다.
 */
let ShowMoreButton = class ShowMoreButton extends lit_1.LitElement {
    render() {
        return (0, lit_1.html) `
      <mm-button variant="tertiary" icon=${icon_names_1.ICON_NAMES.EXPAND} icon-position="trailing">
        더 불러오기
      </mm-button>
    `;
    }
};
ShowMoreButton.styles = (0, lit_1.css) `
    :host {
      display: flex;
      justify-content: center;
    }
  `;
ShowMoreButton = __decorate([
    (0, decorators_js_1.customElement)('mm-show-more-button')
], ShowMoreButton);
exports.ShowMoreButton = ShowMoreButton;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoic2hvdy1tb3JlLWJ1dHRvbi5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbInNob3ctbW9yZS1idXR0b24udHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7Ozs7Ozs7O0FBQUEsNkJBQTJDO0FBQzNDLHFEQUFpRDtBQUVqRCxvRUFBZ0U7QUFDaEUsNkNBQTBDO0FBRTFDOzs7O0dBSUc7QUFFSSxJQUFNLGNBQWMsR0FBcEIsTUFBTSxjQUFlLFNBQVEsZ0JBQVU7SUFRNUMsTUFBTTtRQUNKLE9BQU8sSUFBQSxVQUFJLEVBQUE7MkNBQzRCLHVCQUFVLENBQUMsTUFBTTs7O0tBR3ZELENBQUE7SUFDSCxDQUFDOztBQWJNLHFCQUFNLEdBQUcsSUFBQSxTQUFHLEVBQUE7Ozs7O0dBS2xCLENBQUE7QUFOVSxjQUFjO0lBRDFCLElBQUEsNkJBQWEsRUFBQyxxQkFBcUIsQ0FBQztHQUN4QixjQUFjLENBZTFCO0FBZlksd0NBQWMifQ==